module.exports = __webpack_public_path__ + "img/orange_lock.378d292f.gif";